import axios from "axios";
import { emitToastr } from "./Utils";

const API_URL = process.env.NODE_ENV === "development" ? "http://localhost:3005/" : "https://sitesparasaude.com.br/";


class Api {
    login = async (email, password, remember) => {
        const endpoint = "admin/auth";
        let result = await this.authPost(endpoint, { email, password, remember });

        if (result && result.token && result.user) {
            window.localStorage.setItem("token", result.token);
            delete result.token;
            window.localStorage.setItem("user", JSON.stringify(result.user));
            result.login_ok = true;
        }

        return result;
    };

    logout = async () => {
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("token");
        window.location.href = "/login";
    };

    getUser = () => {
        let user = window.localStorage.getItem("user");
        try {
            user = JSON.parse(user);
            return user;
        } catch {
            return {};
        }
    };

    getUserById = async (payload) => {
        return this.authPost("admin/get-user-by-id", payload, {});
    }

    getToken = () => {
        return window.localStorage.getItem("token") || "";
    };

    getRemoteUser = async () => {
        const user = await this.authPost("admin/get-user", {}, {});

        if (user && user._id) {
            window.localStorage.setItem("user", JSON.stringify(user));
            return user;
        }
        else {
            return false;
        }
    };

    uploadProfilePicture = async (image) => {
        const resp = await this.authPost("admin/upload-profile-picture", { image: image }, { multipart: true, formData: true }); //ESSE TEM ESSAS OPÇÕES PORQUE ESTÁ ENVIANDO UMA IMAGEM AO INVÉS DE UM JSON
        return resp;
    };

    uploadImage = async (image, occupationAreaName) => {
        const payload = { image: image };
        if (occupationAreaName !== undefined) payload.occupation_area_name = occupationAreaName;
        const resp = await this.authPost("admin/upload-image", payload, { multipart: true, formData: true });
        return resp;
    };

    createUser = async (payload) => {
        return await this.authPost("admin/create-user", payload, {});
    }

    updateUser = async (payload) => {
        return this.authPost("admin/update-user", payload, {});
    }

    getUsers = async (payload) => {
        return this.authPost("admin/get-users", payload, {});
    }

    getCustomers = async () => {
        const resp = await this.authPost("admin/get-customers", {}, {});
        return resp;
    }

    getAdministrators = async () => {
        const resp = await this.authPost("admin/get-administrators", {}, {});
        return resp;
    }

    recoveryPassword = async (email) => {
        const resp = await this.authPost("admin/send-password-recovery", { email: email }, {});
        return resp;
    };

    changeUserPassword = async (password, old_password) => {
        const resp = await this.authPost("admin/change-user-password", { password, old_password }, {});
        return resp;
    };

    getForms = async () => {
        const resp = await this.authPost("admin/get-forms", {}, {});

        return resp;
    }

    getFormById = async (form_id) => {
        const resp = await this.authPost("admin/get-form-by-id", { id: form_id }, {});

        return resp;
    }

    getFormResponses = async () => {
        const resp = await this.authPost("admin/get-form-responses", {}, {});

        return resp;
    }

    getFormResponseByUserId = async (user_id) => {
        return this.authPost("admin/get-form-response-by-user-id", { user_id }, {})
    }

    getFormResponseById = async (form_response_id) => {
        return this.authPost("admin/get-form-response-by-id", { id: form_response_id }, {})
    }

    createOrUpdateFormResponse = async (form_response) => {
        return this.authPost("admin/create-or-update-form-response", { object: form_response }, {})
    }

    setFormResponseStatus = async (form_response_id, status) => {
        return this.authPost("admin/set-form-response-status", { form_response_id, status }, {});
    }

    createDudaSite = async (item) => {
        return this.authPost("admin/create-duda-site", item, {});
    }

    deleteDudaSite = async (item) => {
        return this.authPost("admin/delete-duda-site", item, {});
    }

    processFormResponse = async (form_response_id) => {
        return this.authPost("admin/process-form-response", { form_response_id }, {});
    }

    exportAnswers = async (form_response_id) => {
        const endpoint = 'admin/export-answers';
        const result = await this.authPost(endpoint, { form_response_id }, { arraybuffer: true });
        return result;
    }


    //VINDI
    getVindiPaidCharges = async (start_date = "2000-01-01T00:00:00.000-03:00", end_date = "2100-01-01T00:00:00.000-03:00") => {
        return this.authPost("vindi/get-paid-charges", { start_date, end_date }, {});
    }

    getVindiNewSubscriptions = async (start_date = "2000-01-01T00:00:00.000-03:00", end_date = "2100-01-01T00:00:00.000-03:00") => {
        return this.authPost("vindi/get-new-subscriptions", { start_date, end_date }, {});
    }

    getVindiPlans = async () => {
        return this.authPost("vindi/get-plans", {}, {});
    }

    getVindiCustomers = async () => {
        return this.authPost("vindi/get-customers", {}, {});
    }

    getVindiSubscriptions = async () => {
        return this.authPost("vindi/get-subscriptions", {}, {});
    }

    getVindiProducts = async () => {
        return this.authPost("vindi/get-products", {}, {});
    }

    createSecretaryAssistantThread = async () => {
        return this.authPost("admin/create-secretary-assistant-thread", {}, {});
    }

    runAssistantMessage = async (thread, text) => {
        return this.authPost("admin/run-assistant-message", { thread, text }, {});
    }

    getSubscriptionActions = async (skip = 0) => {
        return this.authPost("admin/get-subscription-actions", { skip }, {});
    }

    getSubscriptionPlans = async () => {
        return this.authPost("vindi/get-subscription-plans", {}, {});
    }

    createOrUpdateSubscriptionPlan = async (object) => {
        return this.authPost("vindi/create-or-update-subscription-plan", object, {})
    }

    getFormResponseProcessingProgress = async (form_response_id) => {
        return this.authPost("admin/get-form-response-processing-progress", { form_response_id }, {})
    }

    // create-form-response-answers
    createFormResponseAnswers = async (form_response_id, answers) => {
        return this.authPost("admin/create-form-response-answers", {
            object: {
                _id: form_response_id,
                answers: answers
            }
        }, {});
    }

    createFormResponseTexts = async (form_response_id, texts) => {
        return this.authPost("admin/create-form-response-texts", {
            object: {
                _id: form_response_id,
                ramp_up_texts: texts
            }
        }, {});
    }

    getImages(payload) {
        return this.authPost("admin/get-images", payload, {});
    }

    getRampUpElementsByFormId = async (form_id) => {
        return this.authPost("admin/get-ramp-up-elements-by-form-id", { form_id }, {});
    }

    createOrUpdateRampUpElement = async (ramp_up_element) => {
        return this.authPost("admin/create-or-update-ramp-up-element", { object: ramp_up_element }, {});
    }

    getUserSubscriptions = async (payload) => {
        return this.authPost("vindi/get-user-subscriptions", payload, {});
    }

    getUserSubscriptionById = async (payload) => {
        return this.authPost("vindi/get-user-subscription-by-id", payload, {});
    }

    getSubscriptionConfig = async (payload) => {
        return this.authPost("vindi/get-user-subscription-config", payload, {});
    }

    updateSubscriptionConfig = async (payload) => {
        return this.authPost("vindi/update-user-subscription-config", payload, {});
    }

    getSetting = async (name) => {
        return this.authPost("admin/get-setting", { name }, {});
    }

    setSetting = async (name, value) => {
        return this.authPost("admin/set-setting", { name, value }, {});
    }

    searchVindiCustomers = async (payload) => {
        return this.authPost("vindi/search-customers", payload, {});
    }

    getVindiCustomerById = async (payload) => {
        return this.authPost("vindi/get-customer-by-id", payload, {});
    }

    createSocialPlan = async (payload) => {
        return this.authPost("admin/create-social-plan", payload, {});
    }

    getSocialPosts = async (payload) => {
        return this.authPost("admin/get-social-posts", payload, {});
    }

    getSocialPost = async (id) => {
        return this.authPost("admin/get-social-post", { id }, {});
    }

    updateSocialPost = async (id, data) => {
        return this.authPost("admin/update-social-post", { id, data }, {});
    }

    getSubjectSuggestions = async () => {
        return this.authPost("admin/get-subject-suggestions", {}, {});
    }

    generateSubjectSuggestions = async () => {
        return this.authPost("admin/generate-subject-suggestions", {}, {});
    }

    classifyTheme = async (theme_id, classification) => {
        return this.authPost("admin/classify-theme", { theme_id, classification }, {});
    }

    getSearchData = async (query, theme_id) => {
        return this.authPost("admin/get-search-data", { query, theme_id }, {});
    }

    getLinkPreview = async (url) => {
        return this.authPost("admin/get-link-preview", { url }, {});
    }

    reviseTextWithAI = async (text, instructions) => {
        return this.authPost("admin/revise-text-with-ai", { text, instructions }, {});
    }

    generateArticleV2 = async (payload) => {
        return this.authPost("admin/generate-article-v2", payload, {});
    }

    createArticleContent = async (payload) => {
        return this.authPost("admin/create-article-content-v2", payload, {});
    }

    saveArticleContentV2 = async (payload) => {
        return this.authPost("admin/save-article-content-v2", payload, {});
    }

    updateArticleMetadataV2 = async (payload) => {
        return this.authPost("admin/update-article-metadata", payload, {});
    }

    scheduleArticleV2 = async (payload) => {
        return this.authPost("admin/schedule-article", payload, {});
    }

    publishArticleNowV2 = async (payload) => {
        return this.authPost("admin/publish-article-now", payload, {});
    }

    listArticlesV2 = async (payload = {}) => {
        return this.authPost("admin/list-articles-v2", payload, {});
    }

    getArticleByIdV2 = async (article_id) => {
        return this.authPost("admin/get-article-by-id-v2", { article_id }, {});
    }

    deleteArticleV2 = async (article_id) => {
        return this.authPost("admin/delete-article-v2", { article_id }, {});
    }

    getSiteAnalytics = async (period = '30d') => {
        return this.authPost("admin/get-site-analytics", { period }, {});
    }

    // ---- Planejamento por calendário ----
    getPlannableThemes = async () => {
        return this.authPost("admin/get-plannable-themes", {}, {});
    }

    createPlan = async (payload) => {
        return this.authPost("admin/create-plan", payload, {});
    }

    getCalendar = async (payload = {}) => {
        return this.authPost("admin/get-calendar", payload, {});
    }

    updateSchedule = async (payload) => {
        return this.authPost("admin/update-schedule", payload, {});
    }

    deleteSchedule = async (schedule_id) => {
        return this.authPost("admin/delete-schedule", { schedule_id }, {});
    }

    clearSchedules = async (payload = {}) => {
        return this.authPost("admin/clear-schedules", payload, {});
    }

    approveScheduledArticle = async (article_id) => {
        return this.authPost("admin/approve-scheduled-article", { article_id }, {});
    }

    generatePlannedArticleNow = async (schedule_id) => {
        return this.authPost("admin/generate-planned-article-now", { schedule_id }, {});
    }

    // [admin/teste] Simula etapas do fluxo automático do calendário.
    simulateScheduleStep = async (schedule_id, action) => {
        return this.authPost("admin/simulate-schedule-step", { schedule_id, action }, {});
    }

    getArticleSettings = async () => {
        return this.authPost("admin/get-article-settings", {}, {});
    }

    updateArticleSettings = async (payload) => {
        return this.authPost("admin/update-article-settings", payload, {});
    }

    // ---- Home guiada de /articles ----
    getArticlesOverview = async () => {
        return this.authPost("admin/get-articles-overview", {}, {});
    }

    updateArticlesOnboarding = async (payload) => {
        return this.authPost("admin/update-articles-onboarding", payload, {});
    }

    // ---- Análise de atendimentos ----
    getConversationAnalysisOptions = async (owner_id = null) => {
        return this.authPost("admin/conversation-analysis/options", { owner_id }, {});
    }

    listClinicConversations = async (payload = {}) => {
        return this.authPost("admin/conversation-analysis/conversations/list", payload, {});
    }

    getClinicConversation = async (id) => {
        return this.authPost("admin/conversation-analysis/conversations/get", { id }, {});
    }

    createClinicConversation = async (payload) => {
        return this.authPost("admin/conversation-analysis/conversations/create", payload, {});
    }

    updateClinicConversationMetadata = async (payload) => {
        return this.authPost("admin/conversation-analysis/conversations/update-metadata", payload, {});
    }

    updateClinicConversationClassification = async (payload) => {
        return this.authPost("admin/conversation-analysis/conversations/update-classification", payload, {});
    }

    deleteClinicConversation = async (id) => {
        return this.authPost("admin/conversation-analysis/conversations/delete", { id }, {});
    }

    analyzeClinicConversation = async (id) => {
        return this.authPost("admin/conversation-analysis/conversations/analyze", { id }, {});
    }

    getConversationDashboard = async (payload) => {
        return this.authPost("admin/conversation-analysis/dashboard", payload, {});
    }

    listConversationDemands = async (payload) => {
        return this.authPost("admin/conversation-analysis/demands/list", payload, {});
    }

    createConversationDemand = async (payload) => {
        return this.authPost("admin/conversation-analysis/demands/create", payload, {});
    }

    updateConversationDemand = async (payload) => {
        return this.authPost("admin/conversation-analysis/demands/update", payload, {});
    }

    reorderConversationDemands = async (payload) => {
        return this.authPost("admin/conversation-analysis/demands/reorder", payload, {});
    }

    deleteConversationDemand = async (payload) => {
        return this.authPost("admin/conversation-analysis/demands/delete", payload, {});
    }

    getWhatsAppIntegrationStatus = async (owner_id = null) => {
        return this.authPost("admin/whatsapp-integration/status", { owner_id }, {});
    }

    connectWhatsAppIntegration = async (payload) => {
        return this.authPost("admin/whatsapp-integration/connect", payload, {});
    }

    disconnectWhatsAppIntegration = async (payload) => {
        return this.authPost("admin/whatsapp-integration/disconnect", payload, {});
    }

    getGoogleBusinessConnection = async (owner_id = null) => {
        return this.authPost("admin/google-business/connection", { owner_id }, {});
    }

    geoSeo = async (action, payload = {}) => {
        return this.authPost("admin/geo-seo/" + action, payload, {});
    }

    asyncExecutions = (action, payload = {}) => {
        return this.authPost("admin/async-executions/" + action, payload, {});
    }

    startGoogleBusinessOAuth = async (owner_id = null) => {
        return this.authPost("admin/google-business/oauth/start", { owner_id }, {});
    }

    listGoogleBusinessLocations = async (owner_id = null) => {
        return this.authPost("admin/google-business/locations", { owner_id }, {});
    }

    selectGoogleBusinessLocation = async (payload) => {
        return this.authPost("admin/google-business/location/select", payload, {});
    }

    getGoogleBusinessDashboard = async (payload) => {
        return this.authPost("admin/google-business/dashboard", payload, {});
    }

    disconnectGoogleBusiness = async (owner_id = null) => {
        return this.authPost("admin/google-business/disconnect", { owner_id }, {});
    }

    checkErrorsWithStatusCode200 = (data) => {
        if (data.error) {
            emitToastr("error", data.message || "Erro não identificado!", "Erro");
        }

        return data;
    };






    get = (url) =>
        axios
            .get(`${API_URL}${url}`)
            .then((response) => this.checkErrorsWithStatusCode200(response.data))
            .catch(() => {
                emitToastr("error", "Erro genérico de servidor!", "Erro");
            });

    authGet = (url, data) =>
        axios
            .get(`${API_URL}${url}`, { headers: { auth: this.getToken() }, params: data })
            .then((response) => this.checkErrorsWithStatusCode200(response.data))
            .catch((err) => {
                if (err && err.response && err.response.status === 401) {
                    emitToastr("error", "Erro de servidor! Confira se as informações enviadas estão completas e no formato correto e tente novamente.", "Erro");
                    if (err.response.data && err.response.data.logoff === true) this.logout();
                } else {
                    if (err.response && err.response.data && err.response.data.error && err.response.data.message) return emitToastr("error", err.response.data.message);
                    console.log("Erro genérico de servidor");
                }
            });

    authPost = (url, data, options) => {
        const headers = { auth: this.getToken() };
        if (options) {
            if (options.multipart) {
                headers["Content-Type"] = "multipart/form-data";
            }
            if (options.formData) {
                let formData = new FormData();
                for (let key in data) {
                    formData.append(key, data[key]);
                }
                data = formData;
            }
        }
        return axios
            .post(`${API_URL}${url}`, data, { headers, responseType: options && options.arraybuffer ? 'arraybuffer' : undefined })
            .then((response) => this.checkErrorsWithStatusCode200(response.data))
            .catch((err) => {
                if (err?.response?.data?.error) {
                    if (err.response.data && err.response.data.logoff === true) this.logout();
                    emitToastr("error", err?.response?.data?.message || "Erro não identificado!", "Erro");
                    return { error: true, message: err?.response?.data?.message || "Erro não identificado!" };
                }

                if (err && err.response && err.response.status === 401) {
                    emitToastr("error", "Erro de servidor! Confira se as informações enviadas estão completas e no formato correto e tente novamente.", "Erro");
                    if (err.response.data && err.response.data.logoff === true) this.logout();
                } else {
                    if (err.response && err.response.data && err.response.data.error && err.response.data.message) {
                        return { error: true, message: err.response.data.message };
                    } else if (err.response && err.response.status) emitToastr("error", err.response.statusText + " (status: " + err.response.status + ")", "Erro");
                    else emitToastr("error", "Erro genérico de servidor!", "Erro");
                    err.response.error = err.response.error || true;
                    return err.response;
                }
            });
    };
}

export default new Api();
